const UAParser = require('ua-parser-js');

// Browsers list is made according to https://goo.gl/qedtoS
function isBrowserWhitelisted(ua) {
  const { browser } = UAParser(ua);
  const version = Number(browser.version.replace(/^(\d+).*/, '$1'));
  return isBrowserWhitelisted.BROWSERS_WHITE_LIST.some(
    (b) => (b.name === browser.name && version >= b.minVersion),
  );
}

isBrowserWhitelisted.BROWSERS_WHITE_LIST = [
  {
    name: 'Chrome',
    minVersion: 49,
  },
  {
    name: 'Firefox',
    minVersion: 53,
  },
  {
    name: 'IE',
    minVersion: 11,
  },
  {
    name: 'Safari',
    minVersion: 9,
  },
  {
    name: 'Android Browser',
    minVersion: 4,
  },
];

module.exports = isBrowserWhitelisted;
